module.exports = __webpack_public_path__ + "img/thumb_padrao_510x170.6e3302a4.svg";